import { h } from 'preact';

const LoadingPulse = ({ modifierClass = '' }) => (
  <div className={`w-loading-pulse ${modifierClass}`}>
    <div />
  </div>
);

export default LoadingPulse;
